import React from "react";
import Advertise from "./Advertise";
import Layout from "./Layout";


const AboutUs = () => {
  return (
    <Layout title="About Us" path="about-us">
      <section className="aboutus-section section-padding" id="aboutus">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-md-8 mb-4">
              <div className="about-us">
                <h3>About Us</h3>
                <p>
                  At <strong>just59</strong>, we are a passionate and dedicated
                  team of IT professionals committed to providing high-quality,
                  free online tools and resources. Our mission is simple: to
                  create a comprehensive, user-friendly platform that offers a
                  wide range of online calculators. These tools are designed to
                  be easy to use, accurate, and accessible to everyone,
                  regardless of their background or expertise. Whether you're
                  looking to manage your finances, track your health, or solve
                  complex mathematical problems, just59 is here to assist you.
                </p>
                <p>
                  Since our inception, <strong>just59</strong> has focused on
                  delivering tools that help individuals make informed decisions
                  in various aspects of their lives. Our website hosts a large
                  and diverse selection of calculators, each crafted with the
                  intention of simplifying complex tasks and providing reliable,
                  data-driven results. From helping people plan their budgets
                  and investments to assisting with health goals and fitness
                  targets, we strive to offer calculators that address a wide
                  range of personal and professional needs.
                </p>
                <h3>Wide Range of Calculators</h3>
                <p>We provide calculators in several key areas:</p>
                <ul>
                  <li>
                    <strong>Financial Calculators:</strong> These tools are
                    designed to assist with budgeting, investing, loans,
                    mortgages, and other financial planning activities. They are
                    based on well-established financial formulas and methods,
                    often sourced from textbooks, financial experts, and trusted
                    resources. Financial calculators undergo a thorough review
                    process to ensure their accuracy and relevance. Experts from
                    leading personal financial advisory firms vet these tools to
                    guarantee that they deliver reliable results for users
                    making important financial decisions.
                  </li>
                  <li>
                    <strong>Health & Fitness Calculators:</strong> These
                    calculators help users track their health, fitness goals,
                    and wellness. They include BMI (Body Mass Index)
                    calculators, calorie calculators, ideal weight calculators,
                    and more. All of these tools are based on proven health
                    principles, and the formulas are sourced from reputable
                    health and medical sources. To ensure the information is
                    sound and accurate, health-related calculators are reviewed
                    and vetted by certified medical professionals.
                  </li>
                  <li>
                    <strong>Mathematical & General Purpose Calculators:</strong>{" "}
                    These calculators are aimed at solving a wide variety of
                    mathematical problems, from basic arithmetic to more complex
                    functions like statistics, algebra, and geometry. They are
                    based on well-known mathematical principles and frequently
                    referenced textbooks.
                  </li>
                </ul>
                <h3>Transparency and Accuracy</h3>
                <p>
                  At <strong>just59</strong>, we understand the importance of
                  transparency, especially when it comes to the formulas we use.
                  For certain calculators that involve formulas with varying
                  interpretations or those that are subject to differing schools
                  of thought (such as in the Ideal Weight Calculator), we strive
                  to provide clarity by offering results from multiple widely
                  accepted formulas. This ensures that our users have all the
                  information they need to make informed decisions based on
                  their specific circumstances.
                </p>
                {/* <h3>Open-Source Code</h3>
                <p>
                  Some of the calculators on <strong>just59</strong> utilize
                  open-source JavaScript components, which are made available
                  under various open-source licenses. This not only ensures that
                  our tools are up-to-date and efficient, but it also allows for
                  transparency in how the calculations are made. Open-source
                  code can be reviewed, modified, and contributed to by anyone,
                  fostering a community-driven approach to development.
                </p> */}
                <h3>Content Sourcing</h3>
                <p>
                  The content behind our calculators comes primarily from
                  reputable textbooks and trusted academic and professional
                  references. We believe in using well-established and widely
                  accepted formulas to ensure that our tools are as accurate and
                  reliable as possible. This is essential for providing users
                  with meaningful results they can trust. A small portion of our
                  descriptive content, such as some explanations and
                  definitions, is sourced from Wikipedia under the GNU Free
                  Documentation License. This allows us to provide additional
                  context and helpful explanations to our users while adhering
                  to open-access content guidelines.
                </p>
                <h3>Commitment to Quality</h3>
                <p>
                  At <strong>just59</strong>, our team is dedicated to creating
                  reliable, free tools for everyone. We are constantly working
                  to update and improve our calculators to ensure they remain
                  accurate, efficient, and accessible. Our goal is to empower
                  individuals with the tools they need to make better decisions,
                  whether they're managing their finances, tracking their
                  health, or solving complex mathematical problems.
                </p>
                <h3>Ownership</h3>
                <p>
                  <strong>just59</strong> is owned and operated by{" "}
                  <strong>just59 Technologies</strong>, a company founded
                  with the vision of making high-quality, useful online tools
                  accessible to all. We are committed to providing free and
                  reliable resources that improve the lives of our users and
                  support them in their personal and professional journeys.
                </p>
              </div>
            </div>
            <Advertise />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AboutUs;
